module.exports = "/dist/img/noshi06.fb90b876.jpg";